var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlockSizeLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,24H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3v18C24,22.7,22.7,24,21,24z M3,2C2.4,2,2,2.4,2,3v18 c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1H3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,13.5h-13C4.7,13.5,4,12.8,4,12s0.7-1.5,1.5-1.5h13c0.8,0,1.5,0.7,1.5,1.5S19.3,13.5,18.5,13.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockSizeLg);
export default __webpack_public_path__ + "static/media/icon-block-size-lg.91ead74c99babeb9c34f03b6e74db31b.svg";
export { ForwardRef as ReactComponent };